export default __webpack_public_path__ + "static/media/sky-vip-lounges.ef8b09b9.jpg";